module.exports = __webpack_public_path__ + "img/ic_food_meat.d3392cde.png";